import "../assets/css/style.css";
import "../assets/css/setup.css";

import Hero from "../components/main/hero";
import About from "../components/main/about";
import Skills from "../components/main/skills";
import Project from "../components/main/project";
import Parcours from "../components/main/parcours";
import Contact from "../components/main/contact";
import Veille from "../components/main/veille";

const Main = () => {
  return (
    <div className="main">
      <Hero />
      <About />
      <Skills />
      <Project />
      <Parcours />
      <Veille />
      <Contact />
    </div>
  );
};

export default Main;
